import {Injectable} from '@angular/core'
import {Mutation} from 'apollo-angular'
import gql from 'graphql-tag'

interface Response {
    removeOrder: Boolean
}

interface Param {
    idOrder: string
}

@Injectable({
    providedIn: 'root'
})
export class RemoveOrderMutation extends Mutation<Response, Param> {
    document = gql`
        mutation($idOrder:ID!){
            removeOrder(idOrder:$idOrder)
        }
    `
}
